import { INeoAction } from './../Actions.interface';
import { STATIC_ACTIONS } from '../../Constants/Actions.constants';

const INITIAL_STATE = '';

export default (state: string = INITIAL_STATE, { type, payload }: INeoAction) => {
  if (type === STATIC_ACTIONS.SEARCH_INPUT_CHANGED) {
    return payload;
  }

  return state;
};
